export default function (value) {
  if (!value) return '';

  return value.toString()
    .split(/(\s+)/)
    .map(part => {
      if (/^\s+$/.test(part)) {
        return part;
      }

      if (part.length === 0) {
        return part;
      }

      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
}
